import React from 'react';
import useVersionCheck from '../hooks/useVersionCheck';

const UpdateNotification = () => {
  const { hasUpdate, newVersion, updateApp, dismissUpdate } = useVersionCheck();

  if (!hasUpdate) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-blue-600 text-white px-4 py-3 shadow-lg">
      <div className="w-full flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <svg className="h-5 w-5 text-blue-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          <span className="font-medium">
            Une nouvelle version est disponible ({newVersion})
          </span>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={updateApp}
            className="bg-white text-blue-600 px-4 py-1 rounded-md text-sm font-medium hover:bg-blue-50 transition-colors"
          >
            Mettre à jour
          </button>
          <button
            onClick={dismissUpdate}
            className="text-blue-200 hover:text-white transition-colors"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
